(() => {
  const configNode = document.getElementById('FrostWishlistConfig');
  const dialog = document.getElementById('FrostWishlist');
  if (!configNode || !dialog) return;
  const config = JSON.parse(configNode.textContent);
  const key = 'frost-asia:wishlist:handles:v1';
  const root = `${config.root.replace(/\/$/, '')}/`;
  const grid = dialog.querySelector('[data-frost-wishlist-grid]');
  const status = dialog.querySelector('[data-frost-wishlist-status]');
  const valid = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,200}$/.test(value) && !['silver-cuban-chain', 'shipping-protection'].includes(value);
  let handles = [];
  let previousFocus;
  let renderId = 0;
  let previousOverflow;
  const imageMapPromise=fetch(config.imageMap).then(response=>response.ok?response.json():{}).catch(()=>({}));
  try { const saved = JSON.parse(localStorage.getItem(key) || '[]'); handles = [...new Set(Array.isArray(saved) ? saved.filter(valid) : [])].slice(0,100); } catch {}
  const label = (kind,title) => config[kind].replace('__TITLE__',title);
  function sync() {
    document.querySelectorAll('[data-frost-wishlist-handle]').forEach(button => {
      const saved = handles.includes(button.dataset.frostWishlistHandle);
      button.setAttribute('aria-pressed',String(saved));
      button.setAttribute('aria-label',label(saved ? 'remove' : 'add',button.dataset.frostWishlistTitle || ''));
    });
  }
  function save() { try { localStorage.setItem(key,JSON.stringify(handles)); } catch {} sync(); }
  async function importLegacy() {
    try {
      if(localStorage.getItem(`${key}:imported`))return;
      const old=JSON.parse(localStorage.getItem('resident-vvs:wishlist:v1') || '[]');
      if(!Array.isArray(old)||!old.length)return;
      const response=await fetch(config.legacyMap);if(!response.ok)return;
      const map=await response.json();
      handles=[...new Set([...handles,...old.map(id=>map[id]).filter(valid)])].slice(0,100);
      save();localStorage.setItem(`${key}:imported`,'1');if(dialog.open)render();
    }catch{}
  }
  function element(tag,className,text) { const node=document.createElement(tag); if(className) node.className=className; if(text)node.textContent=text; return node; }
  async function render() {
    const id=++renderId;
    grid.replaceChildren(); status.textContent=handles.length ? '' : config.empty;
    if(!handles.length) return;
    const snapshot=[...handles];
    const imageMap=await imageMapPromise;
    const results=await Promise.allSettled(snapshot.map(async handle=>{
      const response=await fetch(`${root}products/${encodeURIComponent(handle)}.js`,{credentials:'same-origin'});
      if(!response.ok)throw new Error('Product unavailable');
      return response.json();
    }));
    if(id!==renderId)return;
    let failures=0;
    results.forEach((result,index)=>{
      const handle=snapshot[index];
      const card=element('div','frost-wishlist-item');
      if(result.status==='fulfilled'){
        const product=result.value;
        const link=element('a');link.href=`${root}products/${encodeURIComponent(handle)}`;
        if(product.featured_image){const img=element('img');const imageUrl=new URL(product.featured_image,location.origin);if(['https:','http:'].includes(imageUrl.protocol)){const mapped=imageMap[imageUrl.pathname.split('/').pop()];
          if(mapped&&imageUrl.searchParams.get('v')===mapped.version){img.src=new URL(mapped.file,new URL(config.imageMap,location.origin)).href;img.width=mapped.width;img.height=mapped.height;}else{imageUrl.searchParams.set('width','400');img.src=imageUrl.href;img.width=400;img.height=400;}img.loading='lazy';img.alt=product.title;link.append(img);}}
        link.append(element('p','',product.title));
        link.append(element('strong','',new Intl.NumberFormat(config.locale,{style:'currency',currency:config.currency}).format(product.price/100)));
        card.append(link);
        const remove=element('button','',label('remove',product.title));remove.type='button';remove.dataset.frostWishlistRemove=handle;card.append(remove);
      }else{
        failures++;
        const remove=element('button','',label('remove',handle.replaceAll('-',' ')));remove.type='button';remove.dataset.frostWishlistRemove=handle;card.append(remove);
      }
      grid.append(card);
    });
    if(failures)status.textContent=config.error;
  }
  document.addEventListener('click',event=>{
    const target=event.target instanceof Element ? event.target : null;
    if(!target)return;
    const toggle=target.closest('[data-frost-wishlist-handle]');
    if(toggle){event.preventDefault();const handle=toggle.dataset.frostWishlistHandle;if(!valid(handle))return;handles=handles.includes(handle)?handles.filter(x=>x!==handle):[...handles,handle].slice(-100);save();return;}
    if(target.closest('[data-frost-wishlist-open]')){
      previousFocus=target.closest('[data-frost-wishlist-open]');
      document.querySelector('header-drawer')?.closeMenuDrawer?.(event);
      if(!dialog.open){previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';dialog.showModal();dialog.querySelector('h2').focus();}
      render();
    }
    if(target.closest('[data-frost-wishlist-close]'))dialog.close();
    const remove=target.closest('[data-frost-wishlist-remove]');
    if(remove){handles=handles.filter(x=>x!==remove.dataset.frostWishlistRemove);save();render();dialog.querySelector('h2').focus();}
  });
  dialog.addEventListener('close',()=>{document.body.style.overflow=previousOverflow || '';if(previousFocus?.isConnected)previousFocus.focus();});
  dialog.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}});
  window.addEventListener('storage',event=>{if(event.key===key){try{const next=JSON.parse(event.newValue||'[]');handles=Array.isArray(next)?[...new Set(next.filter(valid))].slice(0,100):[];sync();if(dialog.open)render();}catch{}}});
  new MutationObserver(sync).observe(document.getElementById('MainContent'),{childList:true,subtree:true});
  sync();
  importLegacy();
})();

